import React, { useEffect, useState } from "react";
import GoogleButton from "../Login/GoogleButton";
import GoogleLoginNative from "../Login/GoogleLoginNative";
import AppleLogin from "../Login/AppleLogin";
import WebAppleLogin from "../Login/WebAppleLogin";

/**
 * `gate` is how the account-creation screen holds Apple / Google back until the
 * legal + age checkbox is ticked. It is intercepted here, in the capture phase
 * of a wrapper, rather than inside each provider button: Google, native Google,
 * web Apple and native Apple are four different components with four different
 * click handlers, and one interception point cannot drift out of step with the
 * checkbox the way four could. Screens that legitimately have no checkbox (the
 * sign-in screen) pass no gate and behave exactly as before.
 */
const SocialLogin = ({ gate }) => {
  const blockUntilAccepted = (e) => {
    if (!gate || gate.accepted) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof gate.onBlocked === "function") gate.onBlocked();
  };

  const [isFlutterWebViewReady, setIsFlutterWebViewReady] = useState(false);
  const [deviceType, setDeviceType] = useState("Unknown");

  useEffect(() => {
    const userAgent = navigator.userAgent;

    let device_type = "Unknown";

    if (/Android/i.test(userAgent)) {
      device_type = "A"
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      device_type = "I"
    } else {
      device_type = "W"
    }

    setDeviceType(device_type);

    // Check if device type is iOS from local storage
    const flutterWebView = localStorage.getItem("isFlutterInAppWebViewReady");
    setIsFlutterWebViewReady(flutterWebView === "true");
  }, []); // Run once when component mounts


  return (
    <div
      onClickCapture={blockUntilAccepted}
      aria-disabled={gate && !gate.accepted ? "true" : undefined}
    >
      <div className="flex justify-between w-full mt-2">
        {deviceType === "I" && isFlutterWebViewReady && <AppleLogin />} {/* Render AppleLogin component if device is iOS */}
      </div>

      <div className="flex justify-between w-full mt-2">
        {!isFlutterWebViewReady && <WebAppleLogin />} {/* Render WebAppleLogin component for Web */}
      </div>


      <div className="flex justify-between w-full mt-2">
        {deviceType === "I" && isFlutterWebViewReady ? (
          <GoogleLoginNative />
        ) : (
          <GoogleButton />
        )}
      </div>

    </div>
  );
};

export default SocialLogin;
